export const testIds = {
    newSurvey: 'header2__new-survey',    
    listSurvey: 'header2__list-survey'
};
